import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UrlManageService {

  constructor() { }

  root_url = "http://43.153.4.4:8000/"

  /***************************************** graph search ************************************/
  //获取实体label
  getEntryLabelUrl = this.root_url + "species/graph/labels";
  //获取实体属性
  getEntryPropertiesUrl = this.root_url + "species/graph/nodeKey/";
  //获取关系type
  getRelationLabelUrl = this.root_url + "species/graph/types";
  //获取关系属性\
  getRelationPropertiesUrl = this.root_url + "species/graph/relationshipKey/";
  //查询路径缺失关系
  searchPathWithoutRelation = this.root_url + "ppi/uniprot/queryPath";
  //查询路径
  searchPath = this.root_url + "ppi/uniprot/queryPath";
  //searchPath = "http://192.168.1.104:7900/uniprot/queryPath"
  //下载路径
  downloadPath = this.root_url + "ppi/uniprot/queryPathCSV"
  //下载路径test
  downloadPathTest = "http://43.153.4.4:8000/ppi/uniprot/queryCSVById/22140"


  /***************************************** Protein Search ******************************************/
  //通过名称查询
  getProteinResultByName = this.root_url + "ppi/uniprot/findByNameLike/";
  //通过Accession模糊匹配并分页
  getProteinResultByAccession = this.root_url + "ppi/uniprot/findByAccessionLike/";
  //通过Sequence模糊匹配并分页
  getProteinResultBySeq = this.root_url + "ppi/uniprot/findBySequenceLike/";
  //通过KeyWords模糊匹配
  getProteinResultByKeywords = this.root_url + "ppi/uniprot/findByKeywordsLike/";


  /***************************************** Protein Detail ******************************************/
  getProteinDetail = this.root_url + "ppi/uniprot/nodes/";
  getProteinGraph = this.root_url + "ppi/uniprot/queryPathById/";
}
